
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageTransition from "@/components/PageTransition";

const PrivacyPolicy = () => {
  return (
    <PageTransition>
      <Navbar />
      <main className="min-h-screen pt-24 pb-16">
        <section className="section-padding bg-gradient-to-b from-desert-light to-background">
          <div className="page-container">
            <div className="max-w-3xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold mb-6">Privacy Policy</h1>
              <div className="prose prose-lg max-w-none">
                <p className="text-lg mb-4">Last updated: July 1, 2023</p>
                
                <h2 className="text-2xl font-semibold mt-8 mb-4">1. Introduction</h2>
                <p>Welcome to Desert SEO Surf ("we," "our," or "us"). We are committed to protecting your privacy and handling your data in an open and transparent manner. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, including any other media form, media channel, mobile website, or mobile application related or connected thereto (collectively, the "Site").</p>
                
                <p>Please read this Privacy Policy carefully. By using our Site, you consent to the data practices described in this statement. If you do not agree with the data practices described, you should not use our Site.</p>
                
                <h2 className="text-2xl font-semibold mt-8 mb-4">2. Information We Collect</h2>
                
                <h3 className="text-xl font-medium mt-6 mb-3">2.1 Personal Information</h3>
                <p>We may collect personal information that you voluntarily provide to us when you:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Fill out forms on our website</li>
                  <li>Subscribe to our newsletter</li>
                  <li>Request information or assistance</li>
                  <li>Participate in contests, surveys, or promotions</li>
                  <li>Provide feedback or contact us</li>
                </ul>
                
                <p>The personal information we collect may include:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Name</li>
                  <li>Email address</li>
                  <li>Phone number</li>
                  <li>Business name and address</li>
                  <li>Website URL</li>
                  <li>Information about your business and SEO needs</li>
                </ul>
                
                <h3 className="text-xl font-medium mt-6 mb-3">2.2 Non-Personal Information</h3>
                <p>When you visit our Site, we may automatically collect certain information about your device, including:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>IP address</li>
                  <li>Browser type</li>
                  <li>Operating system</li>
                  <li>Access times</li>
                  <li>Pages viewed</li>
                  <li>Other browsing information</li>
                </ul>
                
                <h3 className="text-xl font-medium mt-6 mb-3">2.3 Cookies and Similar Technologies</h3>
                <p>We use cookies and similar tracking technologies to track activity on our Site and hold certain information. Cookies are files with small amounts of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device.</p>
                
                <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.</p>
                
                <h2 className="text-2xl font-semibold mt-8 mb-4">3. How We Use Your Information</h2>
                <p>We may use the information we collect for various purposes, including to:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Provide, operate, and maintain our website</li>
                  <li>Improve, personalize, and expand our website</li>
                  <li>Understand and analyze how you use our website</li>
                  <li>Develop new products, services, features, and functionality</li>
                  <li>Communicate with you for customer service, updates, and marketing purposes</li>
                  <li>Process your transactions</li>
                  <li>Send you technical notices, updates, security alerts, and support messages</li>
                  <li>Prevent fraudulent activities and security breaches</li>
                  <li>Comply with legal obligations</li>
                </ul>
                
                <h2 className="text-2xl font-semibold mt-8 mb-4">4. Disclosure of Your Information</h2>
                <p>We may share your information in the following situations:</p>
                
                <h3 className="text-xl font-medium mt-6 mb-3">4.1 Business Transfers</h3>
                <p>If we are involved in a merger, acquisition, or asset sale, your information may be transferred as part of that transaction.</p>
                
                <h3 className="text-xl font-medium mt-6 mb-3">4.2 Third-Party Service Providers</h3>
                <p>We may share your information with third-party service providers that perform services for us or on our behalf, including payment processing, data analysis, email delivery, hosting services, customer service, and marketing assistance.</p>
                
                <h3 className="text-xl font-medium mt-6 mb-3">4.3 Legal Requirements</h3>
                <p>We may disclose your information where we are legally required to do so to comply with applicable law, governmental requests, judicial proceedings, court orders, or legal process.</p>
                
                <h3 className="text-xl font-medium mt-6 mb-3">4.4 Protection of Rights</h3>
                <p>We may disclose information to protect our rights, privacy, safety, or property, and that of our clients, you, or others.</p>
                
                <h2 className="text-2xl font-semibold mt-8 mb-4">5. Data Security</h2>
                <p>We use administrative, technical, and physical security measures to protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.</p>
                
                <h2 className="text-2xl font-semibold mt-8 mb-4">6. Third-Party Websites</h2>
                <p>Our Site may contain links to third-party websites and applications. We are not responsible for the privacy practices or the content of these third-party sites. Any information you provide on or to a third-party website or application is provided directly to the owner of the website or application and is subject to that party's privacy policy. We encourage you to read the privacy policies of any third-party websites you visit.</p>
                
                <h2 className="text-2xl font-semibold mt-8 mb-4">7. Children's Privacy</h2>
                <p>Our Site is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to take necessary actions.</p>
                
                <h2 className="text-2xl font-semibold mt-8 mb-4">8. Changes to This Privacy Policy</h2>
                <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date at the top of this page. You are advised to review this Privacy Policy periodically for any changes.</p>
                
                <h2 className="text-2xl font-semibold mt-8 mb-4">9. Contact Us</h2>
                <p>If you have any questions about this Privacy Policy, please contact us at:</p>
                <p>Email: privacy@desertseosurf.com</p>
                <p>Phone: (555) 123-4567</p>
                <p>Address: 123 Desert Way, Phoenix, AZ 85001</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </PageTransition>
  );
};

export default PrivacyPolicy;
